import { machineTypeSchema } from "@packsize/schemas/machines";

export const FUSION_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.Fusion }] as const;
